import React from 'react';
import allAboardLogo from '../../assets/images/logo.png';
import ProfilePicture from './ProfilePicture/ProfilePicture';
import ToggleMenu from './ToggleMenu/ToggleMenu';
import Notification from './Notification/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import { retrieveData } from '../../common/CommonExport';
import { toggleEmployeeTable } from '../../redux/employeetable/employeeTableAction';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setEmployeePermission, setSwitchEmployee } from '../../redux/slices/employeePermissionSlice';
import { Tooltip } from 'antd';
import switchIcon from '../../assets/images/acc_switch.svg'
import { useIsMobile } from '../../hooks/commonHooks';

export default function Header() {
    const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);

    const loginUserData = useSelector((state: any) => state?.loginUserData?.userData?.data);
    const name = loginUserData?.name || `${employeeDetails?.firstName || ''} ${employeeDetails?.lastName || ''}`;
    const email = loginUserData?.email || employeeDetails?.officialEmail || '';

    const { switchToEmployeeView, isActiveSwitchIcon, employeePermission, isActiveHrLogin, isAdmin } = useSelector((state: any) => state?.employeePermissionSlice)

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const isMobile = useIsMobile();
    // const loginUserData = retrieveData('loginUserData', true);
    const routesToHideHeader = ['/', '/login', '/forgot-password', '/reset-password', '/probation-completion/',
        '/employee-information-form/', '/preview-document-detail/', '/preview-document-detail', '/employee-designation-approval', '/set-password', '/preview-document'
        , '/employee-bonus-update-status/', '/register', '/signup', '/signup/verification', "/signup/payments", '/home', '/leave-request-update-status/', '/deprovision-form', "/employee-deprovision-update-status", "/leave-request-update-status", '/privacy-policy', "/exit-interview-success", "/basic-form-success", "/employee-salary-increment-status/", "/employee-document-submission-form/", "/employee-resignation-form/", "/job-description"];
    if (routesToHideHeader.includes(location.pathname)) {
        return null;
    }
    const handleNavigate = () => {
        dispatch(toggleEmployeeTable(false))
        if (employeePermission) {
            navigate(`/user-dashboard`);
        } else {
            navigate(`/home/dashboard`);
        }
    }
    const handleSwitch = () => {
        dispatch(setSwitchEmployee(!switchToEmployeeView))
        if (switchToEmployeeView) {
            dispatch(setEmployeePermission(false))
            navigate(`/home/dashboard`);
        } else {
            navigate(`user-dashboard`);
        }
    }
    const isEmployeeDashboard = () => {

        const { pathname } = location;
        return (pathname.includes('/employee/details') || pathname.includes('/home/dashboard'));
    };
    return (
        <div className='header'>
            <div className='container mx-auto max-w-full md:px-14 px-4'>
                <div className='header__menu flex justify-between items-center'>
                    <div className='header__leftSideMenu flex'>
                        {(isEmployeeDashboard() && isMobile) ? null : <ToggleMenu />}

                        <img alt='logo' src={allAboardLogo} className='logo cursor-pointer' onClick={() => handleNavigate()} />
                        <p className='ml-3 cursor-pointer' onClick={() => handleNavigate()}>All-Aboard!</p>
                    </div>
                    <div className='header__rightSideMenu'>
                        <ul className='flex items-center'>

                            <li className='flex flex-col'>
                                <span className='font-semibold'>Welcome {name}</span>
                                {email && (
                                    <span className='text-sm text-gray-500'>
                                        {email}
                                    </span>
                                )}
                            </li>
                            {!employeePermission && !isMobile &&
                                <li>
                                    <Notification />
                                </li>
                            }

                            {isActiveSwitchIcon && !isActiveHrLogin &&
                                <Tooltip className='' title={isMobile ? "" : `Switch to ${switchToEmployeeView ? "Admin" : "Employee"} View`}>
                                    <img src={switchIcon} alt="switch-icon" className='w-[29px] ml-1  mr-3  cursor-pointer' onClick={handleSwitch} />
                                </Tooltip>

                            }
                            <li>
                                <ProfilePicture />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
